import { render, staticRenderFns } from "./OrderFoodView.vue?vue&type=template&id=3e5f884f&"
import script from "./OrderFoodView.vue?vue&type=script&lang=js&"
export * from "./OrderFoodView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fod/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports